module.exports = __webpack_public_path__ + "img/food-circle-2.81eec019.png";